"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var ThemeProvider_1 = require("@cvent/carina/components/ThemeProvider/ThemeProvider");
var BreakpointsProvider_1 = require("@cvent/carina/components/Breakpoints/BreakpointsProvider");
var BlockContext_1 = require("./BlockContext");
var BlocksTypography_1 = require("./BlocksTypography");
var useBuildThemes_1 = __importDefault(require("../hooks/useBuildThemes"));
var BlockWithTypography_1 = __importDefault(require("./BlockWithTypography"));
var constants_1 = require("../utils/constants");
function Block(_a) {
    var children = _a.children;
    return children;
}
exports.Block = Block;
function BlockListItem(_a) {
    var children = _a.children, blockColor = _a.blockColor;
    var _b = (0, BreakpointsProvider_1.useBreakpoints)(), isM = _b.isM, isL = _b.isL, isXL = _b.isXL;
    // Small and below
    var padding = '32px 0px';
    if (isM) {
        padding = '48px 0px';
    }
    else if (isL || isXL) {
        padding = '72px 0px';
    }
    var styles = (0, react_1.useMemo)(function () { return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: blockColor,
        padding: padding,
        flex: 1
    }); }, [blockColor, padding]);
    return ((0, jsx_runtime_1.jsx)("li", __assign({ css: styles }, { children: (0, jsx_runtime_1.jsx)(BlockWithTypography_1.default, __assign({ blockColor: blockColor, css: {
                // Use grid based layouts to handle margins
                // Setting maxWidth is to handle edge cases
                maxWidth: constants_1.blockMaxWidth,
                flex: 1
            } }, { children: children })) })));
}
function Blocks(_a) {
    var children = _a.children, primary = _a.primary, secondary = _a.secondary, background = _a.background, mood = _a.mood, _b = _a.blockColorOrder, blockColorOrder = _b === void 0 ? constants_1.defaultBlockColorOrder : _b, _c = _a.safeMode, safeMode = _c === void 0 ? true : _c, _d = _a.preferFormula, preferFormula = _d === void 0 ? null : _d, themeOverrides = _a.themeOverrides, bodyFont = _a.bodyFont, headingFont = _a.headingFont, props = __rest(_a, ["children", "primary", "secondary", "background", "mood", "blockColorOrder", "safeMode", "preferFormula", "themeOverrides", "bodyFont", "headingFont"]);
    var themes = (0, useBuildThemes_1.default)({
        primary: primary,
        secondary: secondary,
        background: background,
        mood: mood,
        safeMode: safeMode,
        preferFormula: preferFormula,
        bodyFont: bodyFont,
        headingFont: headingFont
    }).themes;
    if (!themes) {
        return null;
    }
    // Remove null children so that color ordering stays consistent
    var filteredChildren = react_1.default.Children.toArray(children).filter(function (child) { return Boolean(child); });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BlocksTypography_1.BlocksTypographyVariables, { headingFont: headingFont, bodyFont: bodyFont }), (0, jsx_runtime_1.jsx)("ul", __assign({ css: [
                    {
                        display: 'flex',
                        flexDirection: 'column',
                        listStyle: 'none',
                        paddingInlineStart: 0,
                        margin: 0,
                        width: '100%',
                        height: '100%',
                        flex: 1,
                        flexGrow: 1
                    }
                ] }, props, { children: react_1.default.Children.map(filteredChildren, function (child, index) {
                    var _a;
                    var blockColorKey = (index === 0 ? constants_1.primaryColorKey : blockColorOrder[(index - 1) % blockColorOrder.length]);
                    var theme = ((_a = themeOverrides === null || themeOverrides === void 0 ? void 0 : themeOverrides[blockColorKey]) !== null && _a !== void 0 ? _a : themes[blockColorKey]);
                    var blockColor = theme.block.base;
                    var context = {
                        index: index,
                        count: filteredChildren.length,
                        blockColorKey: blockColorKey,
                        blockColor: blockColor
                    };
                    return ((0, jsx_runtime_1.jsx)(ThemeProvider_1.ThemeProvider, __assign({ theme: theme }, { children: (0, jsx_runtime_1.jsx)(BlockContext_1.BlockProvider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(BlockListItem, __assign({ blockColor: blockColor }, { children: child })) })) })));
                }) }))] }));
}
exports.default = Blocks;
//# sourceMappingURL=Blocks.js.map